export default {
  login: 'corporate-auth/login',
  loginOTP: 'corporate/otp/loginOtpGenerate',
  verifyLoginOTP: 'corporate/otp/verify',
  getAllMenus: 'corporate/access/getAllMenus',
  getRights: 'corporate/access/getRights',
  advertisements: 'corporate/advertisements',
  Logout: 'corporate-auth/logout',
  userReg: {
    verify: 'corporate/userRegistration/verifyUser',
    register: 'corporate/userRegistration/registerUser',
  },

  calculator: {
    calLoanDep: 'corporate/public/info/calLoanDep',
  },

  fileUpload: {
    getFileProcessList: 'corporate/fileUpload/getFileProcessList',
    initVerify: 'corporate/fileUpload/initVerify',
    initConfirm: 'corporate/fileUpload/initConfirm',
    authVerify: 'corporate/fileUpload/authVerify',
    authConfirm: 'corporate/fileUpload/authConfirm',
    getRecords: 'corporate/fileUpload/getRecords',
    getTrackRecords: 'corporate/fileUpload/getTrackRecords',
    fileUploadView: 'corporate/fileUpload/fileUploadView',
    downloadTemplate: 'corporate/fileUpload/downloadTemplate',
  },

  portfolio: {
    getAccountDetails: 'corporate/accounts/getAll',
    createAccountNickName: 'corporate/accounts/accountNickName',
    assetsAndLiabilities: 'corporate/accounts/assetsAndLiabilities',
    getCASAAccountDetails: 'corporate/accounts/casaDetails',
    getDepositAccountDetails: 'corporate/accounts/details',
    getLoanAccountDetails: 'corporate/accounts/loanDetails',
    getSIList: 'corporate/accounts/si',
    getWalletList: 'corporate/sendTomobile/getwalletlist',
    getMyAccountMiniStatement: 'corporate/statement/topTenTxn',
    getAccountMiniStatement: 'corporate/statement/mini',
    getAccountFullStatement: 'corporate/statement/full',
    accsummary: 'corporate/accountEnquiry/getAccountSummary',
    ministmt: 'corporate/statement/mini',
    fullstmt: 'corporate/statement/full',
    lastNTransactions: 'corporate/others/lastNTransactions',
    getMT103RefNumbers: 'corporate/fundTransfer/getSwiftAndRtgsRef',
    getProofByRange: 'corporate/others/proofByRange',
    salaryDownload: 'corporate/fileUpload/salaryDownload',
    getLoanAccountStatement: 'corporate/accounts/loanStatement',
    getDepositAccountStatement:  'corporate/accounts/depositStatement',
    getListOfFormat: 'corporate/download/getListOfFormat',
    bistatement: 'corporate/download/bistatement',
    tdInterestRatesList: 'corporate/termdeposit/tdInterestRatesList',
    tdCreateinitVerify: 'corporate/termDeposit/initVerify',
    tdCreateinitConfirm: 'corporate/termDeposit/initConfirm',
  },
  userProfile: {
    userDetails: 'corporate/corporateuser/getCorpUser', //'corporate/userActivity/profile',
    userrole: 'corporate/corporateuser/getCorpRole',
    uploadProfileImage: 'corporate/profile/uploadImage',
    removeProfileImage: 'corporate/profile/deleteImage',
    getImage: 'corporate/profile/image',
  },
  si: 'corporate/accountEnquiry/getSIList',
  stmtDownload: 'corporate/pdfreport',
  comments: {
    fundTransfer: 'corporate/fundTransfer/getTrackRecords',
    payment: 'corporate/billPayment/getTrackRecords',
    si: 'corporate/siCreate/getTrackRecords',
    checkbook: 'corporate/chequeBook/getTrackRecords',
    stopCheque: 'corporate/stopcheque/getTrackRecords',
    salaryUpload: 'corporate/fileUpload/getTrackRecords',
    beneficiary: 'corporate/beneficiary/getOtherBeneTrackRecords',
    termDeposite: 'corporate/termDeposit/getTrackRecords',
    debitCard: 'corporate/debitcard/getTrackRecords',
    blockCard: 'corporate/cardStatusChange/getTrackRecords',
  },
  beneficiary: {
    corpOtherBankBeneficiaryVerify: 'corporate/beneficiary/otherBankInitVerify',
    corpInternalBankBeneficiaryVerify: 'corporate/beneficiary/internalInitVerify',
    corpOtherBankBeneficiaryConfirm: 'corporate/beneficiary/otherBankInitConfirm',
    corpInternalBankBeneficiaryConfirm: 'corporate/beneficiary/internalInitConfirm',
    corpInternalBeneficiaryVerification:
      'corporate/fundTransfer/corpInternalBenificiaryVerification',
    addInternalInitBene: 'corporate/fundTransfer/addInternalInitBene',
    getAllAuthBeneList: 'corporate/fundTransfer/getAllAuthBeneList',
    addThirdParty: 'corporate/fundTransfer/addThirdpartyBenificiary',
    addThirdPartyInit: 'corporate/fundTransfer/addOtherBankInitBene',
    modifyInternalOtp: 'corporate/fundTransfer/modifyInternalBenificiaryotp',
    modifyInternalInitBeneVerify: 'corporate/beneficiary/internalInitModifyVerify',
    modifyInternalInitBeneConfirm: 'corporate/beneficiary/internalInitModifyConfirm',
    modifyThirdPartyOtp: 'corporate/fundTransfer/modifyThirdpartyBenificiaryotp',
    modifyOtherInitBene: 'corporate/fundTransfer/initModifyOtherBenificiary',
    generateOTP: 'corporate/fundTransfer/beneficiaryOtpGenerate',
    activate: 'corporate/fundTransfer/activateBenificiary',
    removeInitBeneVerify: 'corporate/beneficiary/removeBeneVerify',
    removeInitBeneConfirm: 'corporate/beneficiary/removeBeneConfirm',
    removeOtp: 'corporate/fundTransfer/removeBenificiaryotp',
    uploadImage: 'corporate/beneficiary/updateBeneImage',
    moveToOther: 'corporate/fundTransfer/addFavouriteToOtherBene',
    moveToFav: 'corporate/fundTransfer/addFavouriteBenificiary',
    getPhotos: 'corporate/userActivity/getBeneImages',
    intBnfVerfication: 'corporate/fundTransfer/internalBenificiaryVerification',
    getAllAuthBeneGroupList: 'corporate/fundTransfer/getAllAuthBeneGroupList',
    addInitBeneGroup: 'corporate/fundTransfer/addBeneGroupInit',
    removeInitBeneGroup: 'corporate/fundTransfer/removeInitBeneGroup',
    modifyInitBeneGroup: 'corporate/fundTransfer/modifyBeneGroupInit',
    addThirdPartyInitBenificiary: '/corporate/fundTransfer/addThirdPartyInitBenificiary',
    getAllBeneficiariesList: 'corporate/beneficiary/getBeneList',
    modifyInitThirdPartyBenificiaryVerify: 'corporate/beneficiary/otherBankInitModifyVerify',
    modifyInitThirdPartyBenificiaryConfirm: 'corporate/beneficiary/otherBankInitModifyConfirm',
    moveFavouriteToOtherBene: 'corporate/beneficiary/moveFavouriteToOtherBene',
    getBeneficiaryImages: 'corporate/beneficiary/getBeneImages',
    removeBeneficiaryImage: 'corporate/beneficiary/deleteBeneImage',
    getSwiftCountry: 'corporate/beneficiary/getSwiftCountry',
    getInternationalBankDetails: 'corporate/beneficiary/getInternationalBankDetails',
    viewSchedulePayment: 'corporate/schedulepayment/viewScheduledPayments',
    verifyCancelScheduledPayments: 'corporate/schedulepayment/cancelScheduledPaymentVerify',
    confirmCancelScheduledPayments: 'corporate/schedulepayment/cancelScheduledPaymentConfirm',
  },
  fundTransfer: {
    bulkft: 'corporate/fundTransfer/initVerifyBulk',
    bulkftConfirm: 'corporate/fundTransfer/initConfirmBulk',
    crpFt: 'corporate/fundTransfer/initVerify',
    crpFtConfirm: 'corporate/fundTransfer/initConfirm',
    ft: 'corporate/fundTransfer/ftInitiator',
    ftConfirm: 'corporate/fundTransfer/ftInitiatorConfirm',
    bulkInit: 'corporate/fundTransfer/BulkTransferInit',
    bulkInitConfirm: 'corporate/fundTransfer/BulkTransferInitConfirm',
    bulkUploadInitCharges: 'corporate/fundTransfer/bulkfundtransferinit',
    bulkUploadInitConfirm: 'corporate/fundTransfer/bulktransferconfirm',
    getCurrencies: 'corporate/fundTransfer/getSwiftCurrencies',
    invoiceUpload: 'corporate/fundTransfer/invoiceUpload',
  },
  billers: {
    getAllBillers: 'corporate/billPayment/getBillProducts',
    getServiceById: 'corporate/billPayment/getServiceById',
    billPaymentInitiate: 'corporate/billPayment/initConfirm',
    addBiller: 'corporate/billPayment/addBiller',
    getBillerBeneficiaries: 'corporate/billPayment/getBillerList',
    getBillerBeneficiary: 'corporate/billPayment/getBillerBeneficiary',
    getAllBillerBeneficiaries: 'corporate/billPayment/getAllBillerList',
    deleteBillerBene: 'corporate/billPayment/deleteBillerBene',
    getPendingBills: 'corporate/billPayment/getPendingBills',
  },
  cardLessCash: {
    viewToken: 'corporate/cardlesscash/viewToken',
    initVerify: 'corporate/cardlesscash/initVerify',
    initConfirm: 'corporate/cardlesscash/initConfirm',
    getTrackRecords: 'corporate/cardlesscash/getTrackRecords',
    getRecords: 'corporate/cardlesscash/getRecords',
    delete: 'corporate/cardlesscash/delete',
    authVerify: 'corporate/cardlesscash/authVerify',
    authConfirm: 'corporate/cardlesscash/authConfirm',
    cancel: 'corporate/cardlesscash/cancelToken',
  },
  // passwordCriteria: 'corporate/password/getCriteria',
  // changePassword: "corporate/password/change",
  requests: {
    validateAccChequeFlag: 'corporate/requests/validateAccChequeFlag',
    chequeBookAndLeafs: 'corporate/requests/getchequeBookAndLeafs',
    chequeBook: 'corporate/chequeBook/initVerify',
    chequeBookConfirm: 'corporate/chequeBook/initConfirm',
    getAllBanksList: 'corporate/others/branchList',
    stopCheque: 'corporate/stopcheque/initVerify',
    stopChequeConfirm: 'corporate/stopcheque/initConfirm',
    addSi: 'corporate/requests/siRequest',
    addSiConfirm: 'corporate/requests/siRequestConfirm',
    siCreateInit: 'corporate/siCreate/initVerify',
    siConfirmInit: 'corporate/siCreate/initConfirm',
    siRequest: 'corporate/requests/siRequest',
    siRequestConfirm: 'corporate/requests/siRequestConfirm',
    debitCard: 'corporate/requests/debitCard',
    debitCardConfirm: 'corporate/requests/debitCardConfirm',
    blockDebitCard: 'corporate/requests/blockDebitCard',
    blockDebitCardConfirm: 'corporate/requests/blockDebitCardConfirm',
    getAllAutheStatementList: 'corporate/requests/getAllAutheStatementList',
    initiateCardlessCash: 'corporate/fundTransfer/initiateCardlessCash',
    loanRequest: 'corporate/loan/loanRequest',
    getLoanRequestValues: 'corporate/loan/getLoanRequestValues',
    getStopChequeReasonList: 'corporate/access/getStopChequeReasonList',
    verifyChequeStatus: 'corporate/chequeStatus/verify',
    confirmChequeStatus: 'corporate/chequeStatus/confirm',
    debitCardInit: 'corporate/debitcard/initVerify',
    debitCardConfirm: 'corporate/debitcard/initConfirm',
    getAllCardProducts: 'corporate/debitcard/getAllCardProducts',
    getAllCardList: 'corporate/debitcard/getDebitCardDetails',
    blockDebitCardVerify: 'corporate/cardStatusChange/initVerify',
    blockDebitCardConfirm: 'corporate/cardStatusChange/initConfirm',
  },
  bankCodes: 'corporate/fundTransfer/rtgsBankcodes',
  //getAllBanks: 'corporate/fundTransfer/getAllBanks',
  getAllBanks: 'corporate/beneficiary/getBankList',
  getCardList: 'corporate/cards/getCardList',
  getUserProfileImage: 'corporate/profile/image',
  changePwd: 'corporate/password/change',
  forceChangePwd: 'corporate/password/forceChange',
  currencyValues: 'corporate/fundTransfer/currencyValues',
  forgotPassword: {
    // verifyUserDetails: "corporate/forgotPwd/forgotPwdVerify",
    confirmPassword: 'corporate/public/forgotPwd/forgotPwdConfirm',
    companyList: 'corporate/forgotPwd/companyList',
    forgotPasswordCriteria: 'corporate/public/forgotPwd/getPwdCriteria',
    passwordCriteria: 'corporate/password/getCriteria',
    forgotPasswordVerify: 'corporate/public/forgotPwd/forgotPwdVerify',
  },
  approvals: {
    fundTransferList: 'corporate/fundTransfer/getRecords',
    stopChequePaymentList: 'corporate/stopcheque/getRecords',
    corpBeneList: 'corporate/beneficiary/getRecords',
    siCreateRequestList: 'corporate/requests/siCreateRequestList',
    siGetRecords: 'corporate/siCreate/getRecords',
    chequeBookRequestList: 'corporate/chequeBook/getRecords',
    generateOtp: 'corporate/otp/generateOtp',
    removeAuthBene: 'corporate/fundTransfer/removeAuthBene',
    modifyAuthThirdPartyBenificiary: 'corporate/fundTransfer/modifyAuthThirdPartyBenificiary',
    addThirdPartyAuthBenificiary: 'corporate/fundTransfer/addThirdPartyAuthBenificiary',
    beneficiaryVerifyAuthRequest: 'corporate/beneficiary/authVerify',
    beneficiaryConfirmAuthRequest: 'corporate/beneficiary/authConfirm',
    beneficiaryDeleteRequest: 'corporate/beneficiary/delete',
    siVerifyAuthRequest: 'corporate/siCreate/authVerify',
    siCreateAuthRequest: 'corporate/siCreate/authConfirm',
    siDelete: 'corporate/siCreate/delete',
    chequeBookDelete: 'corporate/chequeBook/delete',
    chequeBookVerifyAuthRequest: 'corporate/chequeBook/authVerify',
    chequeBookAuthRequest: 'corporate/chequeBook/authConfirm',
    stopChequePaymentVerifyAuthRequest: 'corporate/stopcheque/authVerify',
    stopChequePaymentAuthRequest: 'corporate/stopcheque/authConfirm',
    stopChequeDelete: 'corporate/stopcheque/delete',
    debitCardGetRecords: 'corporate/debitcard/getRecords',
    debitCardAuthVerify: 'corporate/debitcard/authVerify',
    debitCardAuthConfirm: 'corporate/debitcard/authConfirm',
    debitCardDelete: 'corporate/debitcard/delete',
    debitCardDownload: 'corporate/debitcard/dbRecDownload',
    transferVerifyAuthRequest: 'corporate/fundTransfer/authVerify',
    transferAuthRequest: 'corporate/fundTransfer/authConfirm',
    transferDelete: 'corporate/fundTransfer/delete',
    crpFtAuthRequest: 'corporate/fundTransfer/crpFtAuthRequest',
    getSalaryUploadList: 'corporate/fileUpload/getRecords',
    salaryDownloadatinitlevel: 'corporate/fileUpload/salaryDownloadatinitlevel',
    getSalaryUploadAuthTrackDetails: 'corporate/fileUpload/getTrackRecords',
    debitCardRequestList: 'corporate/requests/debitCardRequestList',
    blockDebitCardRequestList: 'corporate/requests/blockDebitCardRequestList',
    addInternalBeneAuth: 'corporate/fundTransfer/addInternalBeneAuth',
    getBillPaymentRequestList: 'corporate/billPayment/getRecords',
    getTDList: 'corporate/termDeposit/getRecords',
    billPaymentVerifyAuthRequest: 'corporate/billPayment/authVerify',
    TDVerifyAuthRequest: 'corporate/termDeposit/authVerify',
    billPayAuthRequest: 'corporate/billPayment/authConfirm',
    TDAuthRequest: 'corporate/termDeposit/authConfirm',
    tdDelete: 'corporate/termdeposit/delete',
    billPayDelete: 'corporate/billPayment/delete',
    debitCardAuthRequest: 'corporate/requests/debitCardAuthRequest',
    blockDebitCardAuthRequest: 'corporate/requests/blockDebitCardAuthRequest',
    salaryUploadAuthVerifyRequest: 'corporate/fileUpload/authVerify',
    salaryUploadAuthRequest: 'corporate/fileUpload/authConfirm',
    salaryUploadDelete: 'corporate/fileUpload/delete',
    authModifyInternalBenificiary: 'corporate/fundTransfer/authModifyInternalBenificiary',
    getCardlessCashList: 'corporate/fundTransfer/getCardlessCashList',
    cardlessCashAuthRequest: 'corporate/fundTransfer/cardlessCashAuthRequest',
    getSIAuthTrackDetails: 'corporate/siCreate/getTrackRecords',
    getStopChequeAuthTrackDetails: 'corporate/stopcheque/getTrackRecords',
    getChequeBookAuthTrackDetails: 'corporate/chequeBook/getTrackRecords',
    getFundTransferAuthTrackDetails: 'corporate/fundTransfer/getTrackRecords',
    getInternalBeneficiaryAuthTrackDetails: 'corporate/beneficiary/getInternalBeneTrackRecords',
    getOtherBeneficiaryAuthTrackDetails: 'corporate/beneficiary/getOtherBeneTrackRecords',
    getBillPaymentAuthTrackDetails: 'corporate/billPayment/getTrackRecords',
    getBillQuote: 'corporate/billPayment/initVerify',
    getAuthTrackDetails: 'corporate/fileUpload/getTrackRecords',
    getcardlessGenTokenList: 'corporate/cardless/cardlessGenTokenList',
    getcardlessTokenAuth: 'corporate/cardless/cardlessGenTokenAuth',
    getCardLoadList: 'corporate/mobileTransfer/cardLoadList',
    chargeForFT: 'corporate/fundTransfer/chargeForFT',
    getCardAccounts: 'corporate/mobileTransfer/getCardAccounts',
    cardLoadVerify: 'corporate/mobileTransfer/cardLoadVerify',
    cardLoadConfirm: 'corporate/mobileTransfer/cardLoadConfirm',
    cardLoadAuth: 'corporate/mobileTransfer/cardLoadAuth',

    getCardlessViewToken: 'corporate/cardless/cardlessViewToken',
    cardlessCancelToken: 'corporate/cardless/cardlessCancelToken',
    mobileTransferVerify: 'corporate/mobileTransfer/mobileTransferVerify',
    mobileTransferConfirm: 'corporate/mobileTransfer/mobileTransferConfirm',
    mobileTransferList: 'corporate/mobileTransfer/mobileTransferList',
    mobileTransferAuth: 'corporate/mobileTransfer/mobileTransferAuth',

    ftPendingDownload: 'corporate/fundTransfer/ftRecDownload',
    BenePendingDownload: 'corporate/beneficiary/beneRecDownload',
    billPendingDownload: 'corporate/billPayment/paymentRecDownload',
    cbPendingDownload: 'corporate/chequeBook/cbRecDownload',
    scPendingDownload: 'corporate/stopcheque/scRecDownload',
    siPendingDownload: 'corporate/siCreate/siRecDownload',
    suPendingDownload: 'corporate/fileUpload/suRecDownload',
    dbPendingDownload: '/corporate/debitcard/dbRecDownload',

    blockCardGetRecords: 'corporate/cardStatusChange/getRecords',
    blockCardAuthVerify: 'corporate/cardStatusChange/authVerify',
    blockCardAuthConfirm: 'corporate/cardStatusChange/authConfirm',
    blockCardDelete: 'corporate/cardStatusChange/delete',
    blockCardDownload: 'corporate/cardStatusChange/dbRecDownload',
  },

  userActions: {
    lastNtxns: 'corporate/receipt/transactions',
    lastNactivities: 'corporate/others/lastNTxnsByCust',
    pdfreceipt: 'corporate/receipt/download',
    suStatusRecord: 'corporate/fileUpload/suStatusRecord',
    getMt103receipt: 'corporate/fundTransfer/downloadMsgCode',
    downloadStatement: 'corporate/download/statement',
    downloadExcelStatement: 'corporate/download/excelStatement',
    downloadExcelTemplate: 'corporate/download/template',
    downloadlogTemplate: 'corporate/fileUpload/downloadLogs',
    downloadSalaryUploadFile: 'corporate/download/salary',
    salaryDownloadatinitlevelexcel: 'corporate/fileUpload/salaryDownloadatinitlevelexcel',
    initiateSalaryUpload: 'corporate/fileUpload/initVerify',
    invoiceUpload: 'corporate/fundTransfer/invoiceUpload',
    initConfirmSalaryUpload: 'corporate/fileUpload/initConfirm',
    getLocations: 'corporate/public/location/getLocations',
    getOffers: 'corporate/others/offers',
    aboutUs: 'corporate/others/aboutUs',
    terms: 'corporate/access/terms',
    commonTermsNConditions: 'corporate/userActivity/termsAndConditions',
    getTermsandConditions: 'instantloanservices/instantLoan/termsAndConditions',
    getComplaintFeedbackCatg: 'corporate/others/getComplaintFeedbackCatg',
    feedback: 'corporate/others/feedback',
    cbsrates: 'corporate/userRegistration/cbsrates',
    currencyValues: 'corporate/fundTransfer/currencyValues',
    faq: 'corporate/others/faqs',
    salaryUploadView: 'corporate/fileUpload/salaryUploadView',
    crossCurrencyRate: 'corporate/public/info/crossCurrencyRate',
  },
  dahsboard: {
    getBillPaymentCounts: 'corporate/corpDashboard/getBillPaymentCounts',
    getSICounts: 'corporate/corpDashboard/getSICounts',
    getBlockCardCounts: 'corporate/corpDashboard/getBlockCardCounts',
    getDebitCardCounts: 'corporate/corpDashboard/getDebitCardCounts',
    getStopChequeCounts: 'corporate/corpDashboard/getStopChequeCounts',
    getChequeBookCounts: 'corporate/corpDashboard/getChequeBookCounts',
    getFundTransferCounts: 'corporate/corpDashboard/getFundTransferCounts',
    getChequeBookApproveList: 'corporate/corpDashboard/getChequeBookApproveList',
    getChequeBookRejectList: 'corporate/corpDashboard/getChequeBookRejectList',
    getCardlessCashCounts: 'corporate/corpDashboard/getCardlessCashCounts',
    getSalaryUploadCounts: 'corporate/corpDashboard/getSalaryUploadCounts',
    getBeneficiaryCounts: 'corporate/corpDashboard/getBeneficiaryCounts',
    getCardLoadCounts: 'corporate/corpDashboard/getCardLoadCounts',
    getSToMCounts: 'corporate/corpDashboard/getSToMCounts',
    getAllCounts: 'corporate/corpDashboard/getConsolidatedCount',
  },

  SERVICE_LABELS: {
    Topstar: 'Meter No.',
    Airtel_Topup: 'Mobile No.',
    Zamtel_Topup: 'Mobile No.',
    MTN_Topup: 'Mobile No.',
    Zesco: 'Meter No.',
    GOtv: 'IUC No.',
    DStv: 'Smart Card No.',
    LiquidTelecom_Data: 'Account No.',
    MTN_Data: 'Account No.',
    Vodafone: 'Account No.',
    MLife: 'Account No.',
    Afribus: 'Service No.',
    ZRA: 'PRN',
  },
}
